import styled from 'styled-components';
import { devices } from '../../../../constants/device';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${devices.xs} {
    min-height: 100vh;
  }
`;

export const SubtitleBar = styled.div`
  height: 62px;
  margin-left: 22px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${devices.xs} {
    margin-top: 0px;
    margin-left: 0px;
    margin-right: 0px;
    justify-content: center;
    height: auto;

    @media ${devices.xs} {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }
`;

export const NoPatients = styled.div``;

export const MenuItemContent = styled.div`
  display: flex;
  gap: 10px;
  font-family: Inter;
  font-size: 14px;
`;

export const SubtitleText = styled.div`
  color: var(--text, #202e5f);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media ${devices.xs} {
  }
`;

export const SubtitleItems = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
`;

export const Loader = styled.div`
  width: 100%;
  height: 100%;
  & .MuiLinearProgress-root {
    background-color: #e5f0f6;
    /* width: 100px !important;
  height: 100px !important; */
  }

  & .MuiLinearProgress-bar {
    background-color: #0084b1;
    /* width: 100px !important;
  height: 100px !important; */
  }
`;

export const TableBody = styled.div``;

export const ButtonWrapper = styled.div`
  width: 178px;

  @media ${devices.xs} {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: flex;
  gap: 3px;
  width: 100%;

  @media ${devices.xs} {
    flex-direction: column;
    align-items: center;
    height: auto;
  }
`;

export const SearchWrapper = styled.div`
  width: 572px;
  margin-right: 6px;

  @media ${devices.xs} {
    display: none;
  }
`;

export const PopoverWrapper = styled.div`
  border-radius: 5px;
  background: var(--icon, #848a9b);
  width: 98px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Block = styled.div`
  display: flex;
  width: 100%;
`;

export const TicketsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TabWrapper = styled.div`
  padding-top: 15px;
  padding-left: 15px;
  width: 100%;

  background-color: #fff;
  & .demographics {
    display: none;
  }

  @media ${devices.xs} {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .demographics {
      display: inherit;
    }
  }
`;

export const CalendarBar = styled.div`
  height: auto;
`;

export const RecordsWrapper = styled.div`
  padding-right: 15px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
